<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToCalendar'
});
</script>
<template>
	<div :key="langKey" class="to-calendar" :flex="flex ? flex : null" :class="setClass" :style="widthStyle">
		<!-- 内容 -->
		<div class="to-calendar-content">
			<!-- 快捷方式 -->
			<div class="to-calendar-shortcut"></div>

			<!-- 日期 -->
			<div v-if="type !== 'time'" class="to-calendar-date">
				<!-- 头部 -->
				<div class="to-calendar-header">
					<to-icon value="backward" link class="to-calendar-header-prev-year" @click.stop="lastYear"></to-icon>
					<to-icon value="back" link class="to-calendar-header-prev" @click.stop="lastMonth"></to-icon>
					<div class="to-calendar-header-content" :class="{ 'is-unfold': type !== 'month' }" @click.stop="toggleMonthSelector">
						<span class="to-calendar-header-year">{{ year }}{{ t('to.calendar.year.suffix') }}</span>
						<span class="to-calendar-header-month">{{ addZero(month) }}{{ t('to.calendar.month.suffix') }}</span>
					</div>
					<to-icon value="next" link class="to-calendar-header-next" @click.stop="nextMonth"></to-icon>
					<to-icon value="forward" link class="to-calendar-header-next-year" @click.stop="nextYear"></to-icon>
				</div>

				<!-- 年月选择 -->
				<div v-show="monthLayer || type === 'month'" class="to-calendar-picker">
					<to-scroll ref="yearScrollRef" class="to-calendar-year" @top="handlerTop" @bottom="handlerBottom">
						<div v-for="(item, index) in years" :key="index" class="to-calendar-year-item" :class="setYearClass(item)" @click.stop="selectYear(item)">
							<div class="to-calendar-year-item-text">
								{{ item }}
							</div>
						</div>
					</to-scroll>
					<!-- <to-icon value="collapse" link class="to-calendar-year-prev" @click="lastYears"></to-icon> -->
					<!-- <div class="to-calendar-year-list"> -->
					<!-- </div> -->
					<!-- <to-icon value="expand" link class="to-calendar-year-next" @click="nextYears"></to-icon> -->
					<div class="to-calendar-picker-divider"></div>
					<div class="to-calendar-month">
						<div class="to-calendar-month-list">
							<div class="to-calendar-month-item" :class="setMonthClass(1)" @click.stop="selectMonth(1)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m1') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(2)" @click.stop="selectMonth(2)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m2') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(3)" @click.stop="selectMonth(3)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m3') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(4)" @click.stop="selectMonth(4)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m4') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(5)" @click.stop="selectMonth(5)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m5') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(6)" @click.stop="selectMonth(6)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m6') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(7)" @click.stop="selectMonth(7)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m7') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(8)" @click.stop="selectMonth(8)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m8') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(9)" @click.stop="selectMonth(9)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m9') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(10)" @click.stop="selectMonth(10)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m10') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(11)" @click.stop="selectMonth(11)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m11') }}
									</div>
								</div>
							</div>
							<div class="to-calendar-month-item" :class="setMonthClass(12)" @click.stop="selectMonth(12)">
								<div class="to-calendar-month-item-content">
									<div class="to-calendar-month-item-text">
										{{ t('to.calendar.month.m12') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 周 -->
				<div v-show="!(monthLayer || type === 'month')" v-if="type !== 'month'" class="to-calendar-week">
					<div class="to-calendar-week-item">{{ t('to.calendar.week.w0') }}</div>
					<div class="to-calendar-week-item">{{ t('to.calendar.week.w1') }}</div>
					<div class="to-calendar-week-item">{{ t('to.calendar.week.w2') }}</div>
					<div class="to-calendar-week-item">{{ t('to.calendar.week.w3') }}</div>
					<div class="to-calendar-week-item">{{ t('to.calendar.week.w4') }}</div>
					<div class="to-calendar-week-item">{{ t('to.calendar.week.w5') }}</div>
					<div class="to-calendar-week-item">{{ t('to.calendar.week.w6') }}</div>
				</div>

				<!-- 日 -->
				<div v-show="!(monthLayer || type === 'month')" v-if="type !== 'month'" class="to-calendar-day">
					<div v-for="(item, index) in days" :key="index" v-dis="isDisableDay(item)" class="to-calendar-day-item" :class="setDayClass(item)" @click="selectDay(item)">
						<div class="to-calendar-day-item-content">
							<slot :item="item" :index="index">
								<div v-if="item.value" class="to-calendar-day-text">{{ dayText(item.value) }}</div>
								<div v-if="item.point && item.point.length > 0" class="to-calendar-day-points">
									<to-tag v-for="(ipoint, pointIndex) in item.point" :key="pointIndex" v-tip="ipoint.tooltip ? ipoint.tooltip : ''" :type="size === 'large' ? 'dot' : ''" :color="pointColor(ipoint.type)">{{ ipoint.count }}</to-tag>
								</div>
							</slot>
						</div>
					</div>
				</div>

				<!-- 图例 -->
				<div v-show="!(monthLayer || type === 'month')" v-if="legend" class="to-calendar-legend">
					<slot name="legend">
						<!-- <to-tag type="dot" color="danger">逾期未完成</to-tag>
						<to-tag type="dot" color="primary">正常进行中</to-tag>
						<to-tag type="dot" color="success">已完成</to-tag> -->
					</slot>
				</div>
			</div>

			<!-- 时间 -->
			<div v-if="type === 'datetime' || type === 'time'" class="to-calendar-time">
				<div class="to-calendar-time-info">
					<div class="to-calendar-time-info-text">{{ addZero(hour) }}:{{ addZero(minute) }}:{{ addZero(second) }}</div>
				</div>
				<div class="to-calendar-time-content">
					<to-scroll ref="hourScroll" class="to-calendar-time-list">
						<div v-for="item in hours" :key="item" v-dis="isDisableHour(item)" :class="{ 'is-on': hour === item }" class="to-calendar-time-item" @click="selectHour(item)">
							<div class="to-calendar-time-item-text">{{ addZero(item) }}</div>
						</div>
					</to-scroll>
					<to-scroll ref="minuteScroll" class="to-calendar-time-list">
						<div v-for="item in minutes" :key="item" v-dis="isDisableMinute(item)" :class="{ 'is-on': minute === item }" class="to-calendar-time-item" @click="selectMinute(item)">
							<div class="to-calendar-time-item-text">{{ addZero(item) }}</div>
						</div>
					</to-scroll>
					<to-scroll ref="secondScroll" class="to-calendar-time-list">
						<div v-for="item in seconds" :key="item" v-dis="isDisableSecond(item)" :class="{ 'is-on': second === item }" class="to-calendar-time-item" @click="selectSecond(item)">
							<div class="to-calendar-time-item-text">{{ addZero(item) }}</div>
						</div>
					</to-scroll>
				</div>
			</div>
		</div>

		<!-- 操作 -->
		<div v-if="type === 'datetime' || type === 'time'" class="to-calendar-fn">
			<to-button class="to-calendar-fn-now" @click="moment">{{ t('to.common.now') }}</to-button>
			<to-button class="to-calendar-fn-confirm" @click="confirm">{{ t('to.common.confirm') }}</to-button>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, nextTick } from 'vue'
import { t, langKey } from '@touchvue/locale'
import { handleBeforeChange, isPromise } from '@touchvue/utils'
import { calendarProps } from './calendar'
import { useWidthStyle } from '@touchvue/hooks'
import { ToScroll, ToTag } from '@touchvue/components'
import { vDis, vTip } from '@touchvue/directives'

// 组件名称


const props = defineProps(calendarProps)

// Emits定义
const emit = defineEmits<{
	confirm: [value: string]
	change: [value: string]
	beforeChange: [value: string]
	close: []
	'update:modelValue': [value: string]
}>()

// 响应式数据
const changeFrom = ref('out')
const submitValue = ref('')

// 现在时间记录
const curYear = ref(new Date().getFullYear())
const curMonth = ref(new Date().getMonth() + 1)
const curDay = ref(new Date().getDate())

// 默认值
const year = ref<number>(0)
const month = ref<number>(0)
const day = ref<number | null>(null)
const hour = ref<string>('0')
const minute = ref<string>('0')
const second = ref<string>('0')

// 多选默认值
const yearsData = ref<number[]>([]) // ['2022','2023',...]
const monthsData = ref<string[]>([]) // ['01','03',...]
const monthsRangeData = ref<string[]>([]) // ['2022-01','2024-03',...]
const daysData = ref<string[]>([]) // ['01','03',...]
const daysRangeData = ref<string[]>([]) // ['2022-01-01','2024-03-03',...]

// 页面数据
const years = ref<number[]>([])
const days = ref<any[]>([])
const hours = ref<string[]>([])
const minutes = ref<string[]>([])
const seconds = ref<string[]>([])

// 选择层
const monthLayer = ref(false)

// 年份切换器
const tempYear = ref(0) // 临时当前年，选择年月的时候，在选月份之前，年份是尚未确定的
// const yearsPage = ref(0)
// const now = ref(new Date())

const yearScrollRef = ref<InstanceType<typeof ToScroll> | null>(null)
const isClickFlag = ref(false)

// 范围
const start = ref({
	year: 0,
	month: 0,
	day: 0
})
const end = ref({
	year: 0,
	month: 0,
	day: 0
})

const { widthStyle } = useWidthStyle(props.width)

// 计算属性
const setClass = computed(() => {
	let arr: string[] = []
	if (props.type) {
		arr.push(`type-${props.type}`)
	}
	if (props.size === 'large') {
		arr.push('size-large')
	}
	return arr
})

const dayText = computed(() => {
	return (val: number) => {
		// 凡是假期，都加上标记
		const dayStr = year.value + '-' + addZero(month.value) + '-' + addZero(val)
		if (props.holiday.length > 0 && props.holiday.indexOf(dayStr) > -1) {
			return t('to.calendar.day.holiday')
		} else {
			return val
		}
	}
})

const pointColor = computed(() => {
	return (val: number) => {
		if (val === -1) {
			return 'danger'
		}
		if (val === 0) {
			return 'primary'
		}
		if (val === 1) {
			return 'success'
		}
	}
})

const hourz = computed({
	get() {
		return addZero(hour.value)
	},
	set(val: string) {
		hour.value = val
	}
})

const minutez = computed({
	get() {
		return addZero(minute.value)
	},
	set(val: string) {
		minute.value = val
	}
})

const secondz = computed({
	get() {
		return addZero(second.value)
	},
	set(val: string) {
		second.value = val
	}
})

const iValue = computed(() => {
	if (props.range) {
		const startVal = start.value.day || start.value.month ? getStringValue(start.value) : ''
		const endVal = end.value.day || end.value.month ? getStringValue(end.value) : ''
		return `${startVal},${endVal}`
	} else if (props.type === 'month' && props.multiple) {
		return monthsRangeData.value.join(',')
	} else if (props.type === 'date' && props.multiple) {
		return daysRangeData.value.join(',')
	} else {
		return getStringValue()
	}
})

// const maxHour = computed(() => {
// 	let max: string | number | Date
// 	if (typeof props.max === 'string') {
// 		max = props.max.replace(/-/gi, '/')
// 	} else {
// 		max = props.max
// 	}
// 	return new Date(max).getHours()
// })

const isDisableDay = computed(() => {
	return (item: any) => {
		if (year.value && month.value && item.value) {
			let dateString = `${year.value}/${month.value}/${Number(item.value)}`
			let min: string | number | Date
			// 默认使用 2023-03-01 格式时，其 hour = 8 而不是 0，所以要转为 2023/03/01 格式
			if (typeof props.min === 'string') {
				min = props.min.replace(/-/gi, '/')
			} else {
				min = props.min
			}

			let max: string | number | Date
			if (typeof props.max === 'string') {
				max = props.max.replace(/-/gi, '/')
			} else {
				max = props.max
			}

			if (min && max) {
				return new Date(dateString) < new Date(min) || new Date(dateString) > new Date(max)
			}
			if (props.disabledDate) {
				return props.disabledDate(new Date(dateString))
			}
			return false
		} else {
			return false
		}
	}
})

const isDisableHour = computed(() => {
	return (item: string) => {
		if (year.value && month.value && day.value !== null) {
			let dateString = `${year.value}/${month.value}/${day.value} ${Number(item)}:00:00`
			let min: string | number | Date
			// 默认使用 2023-03-01 格式时，其 hour = 8 而不是 0，所以要转为 2023/03/01 格式
			if (typeof props.min === 'string') {
				min = props.min.replace(/-/gi, '/')
			} else {
				min = props.min
			}

			let max: string | number | Date
			if (typeof props.max === 'string') {
				max = props.max.replace(/-/gi, '/')
			} else {
				max = props.max
			}

			if (min && max) {
				return new Date(dateString) < new Date(min) || new Date(dateString) > new Date(max)
			}
			return false
		} else {
			return false
		}
	}
})

const isDisableMinute = computed(() => {
	return (item: string) => {
		if (year.value && month.value && day.value !== null && hour.value) {
			let dateString = `${year.value}/${month.value}/${day.value} ${hour.value}:${Number(item)}:00`
			let min: string | number | Date
			// 默认使用 2023-03-01 格式时，其 hour = 8 而不是 0，所以要转为 2023/03/01 格式
			if (typeof props.min === 'string') {
				min = props.min.replace(/-/gi, '/')
			} else {
				min = props.min
			}

			let max: string | number | Date
			if (typeof props.max === 'string') {
				max = props.max.replace(/-/gi, '/')
			} else {
				max = props.max
			}

			if (min && max) {
				return new Date(dateString) < new Date(min) || new Date(dateString) > new Date(max)
			}
			return false
		} else {
			return false
		}
	}
})

const isDisableSecond = computed(() => {
	return (item: string) => {
		if (year.value && month.value && day.value !== null && hour.value && minute.value) {
			let dateString = `${year.value}/${month.value}/${day.value} ${hour.value}:${minute.value}:${Number(item)}`
			let min: string | number | Date
			// 默认使用 2023-03-01 格式时，其 hour = 8 而不是 0，所以要转为 2023/03/01 格式
			if (typeof props.min === 'string') {
				min = props.min.replace(/-/gi, '/')
			} else {
				min = props.min
			}

			let max: string | number | Date
			if (typeof props.max === 'string') {
				max = props.max.replace(/-/gi, '/')
			} else {
				max = props.max
			}

			if (min && max) {
				return new Date(dateString) < new Date(min) || new Date(dateString) > new Date(max)
			}
			return false
		} else {
			return false
		}
	}
})

// 监听器
watch(
	() => props.modelValue,
	val => {
		if (!(props.type === 'date' && props.multiple)) {
			setData()
		}
		if (changeFrom.value === 'out') {
			submitValue.value = val as string
		}
	},
	{ deep: true }
)

watch(submitValue, val => {
	emit('change', val)
	emit('update:modelValue', val)
	changeFrom.value = 'in'
	setTimeout(() => {
		changeFrom.value = 'out'
	}, 100)
})

watch(
	() => props.min,
	() => {
		// props.min = val
	}
)

watch(
	() => props.max,
	() => {
		// props.max = val
	}
)

watch(
	() => props.point,
	() => {
		setDayData()
	},
	{ deep: true }
)

watch(
	() => year.value,
	() => {
		if (!isClickFlag.value) {
			goToCenter()
		}
	},
	{ deep: true }
)

// 根据 obj 获取当前时间值，入参格式形如：
// arg = {
// 	year: '2022',
// 	month: '02',
// 	day: '22'
// }

const commonSetDayVal = () => {
	if (props.type === 'date' && props.multiple) {
		const mValue = props.modelValue as string
		const mArray = mValue.split(',')
		if (!mArray.length) return
		let yearVal = new Date(mArray[mArray.length - 1] as string).getFullYear()
		let monthVal = new Date(mArray[mArray.length - 1] as string).getMonth() + 1
		let dayVal = new Date(mArray[mArray.length - 1] as string).getDate()
		if (year.value === yearVal && month.value === monthVal) {
			day.value = dayVal
		} else {
			day.value = null
		}
	} else {
		let yearVal = new Date(props.modelValue as string).getFullYear()
		let monthVal = new Date(props.modelValue as string).getMonth() + 1
		let dayVal = new Date(props.modelValue as string).getDate()
		if (year.value === yearVal && month.value === monthVal) {
			day.value = dayVal
		} else {
			day.value = null
		}
	}
}

const handlerTop = () => {
	const minYear = Number(props.minYear || 1900)
	if (Number(years.value[0]) <= minYear) {
		return
	}

	// 通过 ref 获取滚动容器的 DOM 元素
	const scrollRef = yearScrollRef.value?.$el as HTMLElement | null
	if (!scrollRef) return

	const scrollTop = scrollRef.scrollTop

	// 生成新的年份数据
	// years.value[0] - 50
	const newYears = setYearData(years.value[0] - 50)
	// 过滤掉小于最小年份限制的数据
	const filteredYears = newYears.filter(year => year >= minYear)

	if (filteredYears.length > 0) {
		const originalScrollHeight = scrollRef.scrollHeight
		// 更新数据
		years.value = [...filteredYears, ...years.value]

		nextTick(() => {
			if (!scrollRef) return
			// 计算新数据的高度差
			const heightDifference = scrollRef.scrollHeight - originalScrollHeight
			// 设置新的滚动位置，保证视觉上平稳过渡
			scrollRef.scrollTop = scrollTop + heightDifference
		})
	}
}

const handlerBottom = () => {
	const maxYear = Number(props.maxYear || 2200)
	if (Number(years.value[years.value.length - 1]) >= maxYear) {
		return
	}
	// 生成新的年份数据
	const newYears = setYearData(years.value[years.value.length - 1] + 1)
	// 过滤掉超过最大年份限制的数据
	const filteredYears = newYears.filter(year => year <= maxYear)
	if (filteredYears.length > 0) {
		years.value = [...years.value, ...filteredYears]
	}
}

const getValue = (arg: any) => {
	return new Date(`${arg.year || year.value}/${arg.month || month.value}/${arg.day || day.value || '01'}`).getTime()
}

// 获取格式化为字符串后的日期
const getStringValue = (arg: any = {}) => {
	const yearVal = arg.year || year.value
	const monthVal = arg.month || month.value
	const dayVal = arg.day || day.value
	const hourVal = arg.hour || hourz.value
	const minuteVal = arg.minute || minutez.value
	const secondVal = arg.second || secondz.value
	const imonth = `${yearVal}-${addZero(monthVal)}`
	const iday = dayVal !== null && dayVal !== undefined ? `${addZero(dayVal)}` : '01'
	const itime = `${hourVal}:${minuteVal}:${secondVal}`
	if (props.type === 'month') {
		return imonth
	} else if (props.type === 'datetime' || props.type === 'time') {
		return `${imonth}-${iday} ${itime}`
	} else {
		return `${imonth}-${iday}`
	}
}

// 获取格式化为对象的日期
const getObjectValue = (str: string) => {
	const date = new Date(str)
	if (isDate(str) && str) {
		return {
			year: date.getFullYear(),
			month: date.getMonth() + 1,
			day: date.getDate()
		}
	} else if (isMonth(str) && str) {
		return {
			year: date.getFullYear(),
			month: date.getMonth() + 1,
			day: 0
		}
	} else {
		return {
			year: 0,
			month: 0,
			day: 0
		}
	}
}

// 数据设置
const setData = () => {
	setCurrent()
	setDayData()
	setTimeData()
}

const setCurrent = () => {
	year.value = 0
	month.value = 0
	day.value = null
	if (props.range) {
		let arr = (props.modelValue as string).split(',')
		const startVal = arr[0]
		const endVal = arr[1]

		if (!startVal || isDate(startVal) || isMonth(startVal)) {
			start.value = getObjectValue(startVal)
			if (!endVal || isDate(endVal) || isMonth(endVal)) {
				end.value = getObjectValue(endVal)
			}
		}
		if (props.rangeType === 'end') {
			year.value = year.value || new Date().getFullYear()
			if ((end.value.day || end.value.month) && isAnyDate(getStringValue(end.value))) {
				if (props.type === 'month') {
					if (start.value.year === end.value.year) {
						year.value = end.value.year + 1
					} else {
						year.value = end.value.year
					}
					month.value = 1
				} else {
					if (start.value.month === end.value.month) {
						if (Number(month.value) === 12) {
							year.value = end.value.year + 1
							month.value = 1
						} else {
							month.value = end.value.month + 1
						}
					} else {
						month.value = end.value.month
					}
				}
			} else {
				month.value = month.value || new Date().getMonth() + 2
			}
			if (month.value > 12) {
				month.value = 1
				year.value += 1
			}
		} else {
			if ((start.value.day || start.value.month) && isAnyDate(getStringValue(start.value))) {
				year.value = start.value.year
				month.value = start.value.month
			} else {
				year.value = year.value || new Date().getFullYear()
				month.value = month.value || new Date().getMonth() + 1
			}
		}
	} else {
		if (props.modelValue && (!isNaN(new Date(props.modelValue as string).getTime()) || (props.type === 'month' && props.multiple) || (props.type === 'date' && props.multiple))) {
			if ((props.type === 'month' && props.multiple) || (props.type === 'date' && props.multiple)) {
				const mValue = props.modelValue as string
				const mArray = mValue.split(',')
				if (!mArray.length) return
				year.value = new Date(mArray[mArray.length - 1] as string).getFullYear()
				month.value = new Date(mArray[mArray.length - 1] as string).getMonth() + 1
				day.value = new Date(mArray[mArray.length - 1] as string).getDate()
				hour.value = String(new Date(mArray[mArray.length - 1] as string).getHours())
				minute.value = String(new Date(mArray[mArray.length - 1] as string).getMinutes())
				second.value = String(new Date(mArray[mArray.length - 1] as string).getSeconds())
				if (props.type === 'month' && props.multiple) {
					monthsRangeData.value = mArray
					if (monthsRangeData.value.length > 0) {
						setMonthsData()
					}
				}
				if (props.type === 'date' && props.multiple) {
					daysRangeData.value = mArray
					if (daysRangeData.value.length > 0) {
						setDaysData()
					}
				}
			} else {
				year.value = new Date(props.modelValue as string).getFullYear()
				month.value = new Date(props.modelValue as string).getMonth() + 1
				day.value = new Date(props.modelValue as string).getDate()
				hour.value = String(new Date(props.modelValue as string).getHours())
				minute.value = String(new Date(props.modelValue as string).getMinutes())
				second.value = String(new Date(props.modelValue as string).getSeconds())
			}
		} else if (props.modelValue && isNaN(new Date(props.modelValue as string).getTime()) && !isNaN(new Date((props.modelValue as string).replace(/-/g, '/')).getTime())) {
			const value = (props.modelValue as string).replace(/-/g, '/')
			year.value = new Date(value).getFullYear()
			month.value = new Date(value).getMonth() + 1
			day.value = new Date(value).getDate()
			hour.value = String(new Date(value).getHours())
			minute.value = String(new Date(value).getMinutes())
			second.value = String(new Date(value).getSeconds())
		} else {
			year.value = new Date().getFullYear()
			month.value = new Date().getMonth() + 1
			day.value = null
			hour.value = '0'
			minute.value = '0'
			second.value = '0'
		}
	}
}

const filterYearData = (arr: number[]) => {
	// 过滤掉小于 props.minYear 和大于 props.maxYear 的值
	const minYear = Number(props.minYear || 1900)
	const maxYear = Number(props.maxYear || 2200)
	return arr.filter(year => year >= minYear && year <= maxYear)
}

const setYearData = (yearVal?: number) => {
	const minYear = Number(props.minYear || 1900)
	const maxYear = Number(props.maxYear || 2200)
	if (!yearVal) {
		yearVal = year.value >= minYear && year.value <= maxYear ? year.value : minYear
	} else if (yearVal && (yearVal < minYear || yearVal > maxYear)) {
		yearVal = minYear
	} else {
		yearVal = yearVal || year.value
	}

	let arr: number[] = []
	if (yearVal === year.value) {
		for (let i = -25; i < 25; i++) {
			arr.push(yearVal + i)
		}
	} else {
		for (let i = 0; i < 50; i++) {
			// arr.push(Math.floor(yearVal / 10) * 10 + i)
			arr.push(yearVal + i)
		}
	}

	return filterYearData(arr)
}

const setDayData = () => {
	commonSetDayVal()
	// 计算本月天数
	const dayCount = getMonthDays(`${year.value}/${month.value}/1`)

	// 计算前面有几天应该置空
	const thisMonthFirstDay = new Date(`${year.value}/${month.value}/1`)
	thisMonthFirstDay.setMonth(thisMonthFirstDay.getMonth(), 1)
	const emptyLength = new Date(thisMonthFirstDay.setMonth(thisMonthFirstDay.getMonth(), 1)).getDay()

	// 设置天数
	days.value = (() => {
		let arr: any[] = []
		for (let i = 0; i < emptyLength; i++) {
			arr.push({})
		}
		for (let i = 1; i < dayCount + 1; i++) {
			let obj: any = {}
			obj.value = i

			// 星期天
			if ((i + emptyLength) % 7 === 1) {
				obj.sun = true
			}

			// 星期六
			if ((i + emptyLength) % 7 === 0) {
				obj.sat = true
			}

			const point = Array.isArray(props.point)
				? props.point.filter(item => {
						return item.day === `${year.value}-${addZero(month.value)}-${addZero(i)}`
					})
				: []
			obj.point = point

			arr.push(obj)
		}
		return arr
	})()
}

const setTimeData = () => {
	hours.value = genNumbers(0, 23)
	minutes.value = genNumbers(0, 59)
	seconds.value = genNumbers(0, 59)
	const hourVal = String(new Date(props.modelValue as string).getHours())
	const minuteVal = String(new Date(props.modelValue as string).getMinutes())
	const secondVal = String(new Date(props.modelValue as string).getSeconds())
	if (props.time) {
		const arr = props.time.split(':')
		hour.value = arr[0] || '0'
		minute.value = arr[1] || '0'
		second.value = arr[2] || '0'
	}
	if (!isNaN(Number(hourVal)) && !isNaN(Number(minuteVal)) && !isNaN(Number(secondVal))) {
		hour.value = hourVal
		minute.value = minuteVal
		second.value = secondVal
	}
}

const toggleString = (arr, str) => {
	// debugger
	// 检查数组中是否包含目标字符串（使用严格相等 === 判断）
	const hasStr = arr.includes(str)

	if (hasStr) {
		// 过滤掉所有等于目标字符串的元素（删除所有匹配项）
		return arr.filter(item => item !== str)
	} else {
		// 不包含则追加到数组末尾
		return [...arr, str]
	}
}

// 选择事件
const selectYear = (item: number) => {
	year.value = item
	isClickFlag.value = true
}

const selectMonth = (item: number) => {
	if (item) {
		if (props.range && props.type === 'month') {
			let startVal: any = {}
			let endVal: any = {}
			if (!start.value.month && !end.value.month) {
				startVal.year = year.value
				startVal.month = item
				startVal.day = ''
			}
			if (start.value.month) {
				if (end.value.month) {
					startVal.year = year.value
					startVal.month = item
					startVal.day = ''
					endVal.year = ''
					endVal.month = ''
					endVal.day = ''
				} else {
					if (getValue(start.value) > getValue({ month: item })) {
						endVal.year = start.value.year
						endVal.month = start.value.month
						endVal.day = ''
						startVal.year = year.value
						startVal.month = item
						startVal.day = ''
					} else {
						startVal = JSON.parse(JSON.stringify(start.value))
						endVal.year = year.value
						endVal.month = item
						endVal.day = ''
					}
				}
			}
			start.value = JSON.parse(JSON.stringify(startVal))
			end.value = JSON.parse(JSON.stringify(endVal))
			submitValue.value = iValue.value
		} else {
			if (props.type === 'month') {
				emit(
					'beforeChange',
					getStringValue({
						month: item
					})
				)
			}
			if (props.beforeChange) {
				const fn = props.beforeChange(
					getStringValue({
						month: item
					})
				)
				if (fn && isPromise(fn)) {
					;(fn as Promise<boolean>)
						.then(() => {
							selectMonthAction(item)
						})
						.catch(() => {})
				} else {
					// 是同步方法，则返回为 true 执行
					if (fn) {
						selectMonthAction(item)
					}
				}
			} else {
				selectMonthAction(item)
			}
		}
	}
}

const setMonthsData = () => {
	yearsData.value = [
		...new Set(
			monthsRangeData.value.map(item => {
				return Number(item.split('-')[0] ?? curYear.value)
			})
		)
	]
	monthsData.value = [
		...new Set(
			monthsRangeData.value.map(item => {
				return item.split('-')[1] ?? addZero(curMonth.value)
			})
		)
	]
}

const setDaysData = () => {
	yearsData.value = [
		...new Set(
			daysRangeData.value.map(item => {
				return Number(item.split('-')[0] ?? curYear.value)
			})
		)
	]
	monthsData.value = [
		...new Set(
			daysRangeData.value.map(item => {
				return item.split('-')[1] ?? addZero(curMonth.value)
			})
		)
	]
	daysData.value = [
		...new Set(
			daysRangeData.value.map(item => {
				return item.split('-')[2] ?? addZero(curDay.value)
			})
		)
	]
	monthsRangeData.value = [
		...new Set(
			daysRangeData.value.map(item => {
				return item.split('-').slice(0, 2).join('-')
			})
		)
	]
}

const selectMonthAction = (item: number) => {
	month.value = item
	if (props.type === 'month') {
		const str = `${year.value || curYear}-${addZero(month.value)}`
		monthsRangeData.value = toggleString(monthsRangeData.value, str)
		setMonthsData()
	}
	monthLayer.value = false
	setDayData()
	if (props.type === 'month') {
		day.value = 1
		submitValue.value = iValue.value
	}
}

const selectDay = (item: any) => {
	if (item.value) {
		if (props.range) {
			let startVal: any = {}
			let endVal: any = {}
			if (!start.value.day && !end.value.day) {
				startVal.year = year.value
				startVal.month = month.value
				startVal.day = item.value
			}
			if (start.value.day) {
				if (end.value.day) {
					startVal.year = year.value
					startVal.month = month.value
					startVal.day = item.value
					endVal.year = ''
					endVal.month = ''
					endVal.day = ''
				} else {
					if (getValue(start.value) > getValue({ day: item.value })) {
						endVal.year = start.value.year
						endVal.month = start.value.month
						endVal.day = start.value.day
						startVal.year = year.value
						startVal.month = month.value
						startVal.day = item.value
					} else {
						startVal = JSON.parse(JSON.stringify(start.value))
						endVal.year = year.value
						endVal.month = month.value
						endVal.day = item.value
					}
				}
			}
			start.value = JSON.parse(JSON.stringify(startVal))
			end.value = JSON.parse(JSON.stringify(endVal))
			submitValue.value = iValue.value
		} else {
			let val = getStringValue({
				day: item.value
			})
			if (!props.type || props.type === 'date' || (props.type === 'date' && props.multiple)) {
				emit('beforeChange', val)

				handleBeforeChange(
					props.beforeChange,
					getStringValue({
						day: item.value
					})
				)
					.then(() => {
						selectDayAction(item)
					})
					.catch(() => {})
			} else {
				selectDayAction(item)
			}
		}
	}
}

const selectDayAction = (item: any) => {
	day.value = Number(item.value)
	const str = `${year.value || curYear}-${addZero(month.value)}-${addZero(day.value)}`
	daysRangeData.value = toggleString(daysRangeData.value, str)
	setDaysData()
	submitValue.value = iValue.value
}

const selectTime = () => {
	if (day.value === null && !props.min && !props.max) {
		day.value = new Date().getDate()
	} else if (day.value === null && props.min && props.max) {
		// this.$tip.error(this.t('to.calendar.tip.error.selectDate'))
		return
	}
	// emit('beforeChange', getStringValue())
	// if (props.beforeChange) {
	// 	const fn = props.beforeChange(getStringValue())

	// 	if (fn && isPromise(fn)) {
	// 		;(fn as Promise<boolean>).then(() => {
	// 			selectTimeAction()
	// 		})
	// 	} else {
	// 		// 是同步方法，则返回为 true 执行
	// 		if (fn) {
	// 			selectTimeAction()
	// 		}
	// 	}
	// } else {
	// 	selectTimeAction()
	// }
}

const selectTimeAction = () => {
	submitValue.value = iValue.value
	emit('close')
}

const selectHour = item => {
	hour.value = item
	selectTime()
}
const selectMinute = item => {
	minute.value = item
	selectTime()
}
const selectSecond = item => {
	second.value = item
	selectTime()
}

const moment = () => {
	hour.value = String(new Date().getHours())
	minute.value = String(new Date().getMinutes())
	second.value = String(new Date().getSeconds())
	selectTime()
}

const confirm = () => {
	emit('confirm', submitValue.value)

	emit('beforeChange', getStringValue())
	if (props.beforeChange) {
		const fn = props.beforeChange(getStringValue())

		if (fn && isPromise(fn)) {
			;(fn as Promise<boolean>).then(() => {
				selectTimeAction()
			})
		} else {
			// 是同步方法，则返回为 true 执行
			if (fn) {
				selectTimeAction()
			}
		}
	} else {
		selectTimeAction()
	}
}

// 样式设置
const setYearClass = (item: number) => {
	return {
		'is-cur': curYear.value === item,
		'is-on': year.value === item || (((props.type === 'month' && props.multiple) || (props.type === 'date' && props.multiple)) && yearsData.value.includes(item))
	}
}

const setMonthClass = (item: number) => {
	let arr: string[] = []
	if (year.value === curYear.value && curMonth.value === item) {
		arr.push('is-cur')
	}
	if (props.range && props.type === 'month') {
		if (year.value === start.value.year && item === start.value.month) {
			if (end.value.month) {
				arr.push('is-start')
			} else {
				arr.push('is-on')
			}
		}
		if (year.value === end.value.year && item === end.value.month) {
			arr.push('is-end')
		}
		const value = getValue({
			year: year.value,
			month: item,
			day: 1
		})
		console.log('start.value', start.value)
		console.log('end.value', end.value)
		console.log('value', value)
		console.log('getValue(start.value)', getValue(start.value))
		console.log('getValue(end.value)', getValue(end.value))
		if ((value > getValue(start.value) || value === getValue(start.value)) && value < getValue(end.value)) {
			arr.push('is-range')
		}
	} else {
		if (month.value === item && (props.type === 'month' || props.type === 'date' || !props.type)) {
			arr.push('is-on')
		}
		if (((props.type === 'month' && props.multiple) || (props.type === 'date' && props.multiple)) && yearsData.value.length > 0) {
			// monthsData.value.includes(`${addZero(item)}`)
			if (yearsData.value.includes(year.value) && years.value.includes(year.value) && monthsRangeData.value.includes(`${year.value}-${addZero(item)}`)) {
				arr.push('is-on')
			}
		}
	}

	if (item && (props.min || props.max)) {
		let curData = year.value + '/' + (item > 9 ? item : '0' + item) + '/01'
		let date = new Date()
		let hourVal = date.getHours()
		let minuteVal = date.getMinutes()
		let secondVal = date.getSeconds()
		curData = curData + ' ' + (hourVal > 9 ? hourVal : '0' + hourVal) + ':' + (minuteVal > 9 ? minuteVal : '0' + minuteVal) + ':' + (secondVal > 9 ? secondVal : '0' + secondVal)
		let curTime = new Date(curData).getTime()
		let min = new Date(props.min as string).getTime()
		let maxTime = new Date(props.max as string).getTime()
		let cur = curData.split(' ')[0]
		let yearVal = new Date(props.max as string).getFullYear()
		let monthVal = new Date(props.max as string).getMonth() + 1
		let dayVal = new Date(props.max as string).getDate()
		let max = yearVal + '/' + (monthVal > 9 ? monthVal : '0' + monthVal) + '/' + (dayVal > 9 ? dayVal : '0' + dayVal)
		if (min === maxTime && cur !== max) {
			if (curTime > maxTime) {
				arr.push('to-dis')
			}
			if (curTime < min) {
				arr.push('to-dis')
			}
		} else if (min !== maxTime && cur !== max) {
			if (curTime > maxTime) {
				arr.push('to-dis')
			}
			if (curTime < min) {
				arr.push('to-dis')
			}
		}
	}
	return arr
}

const setDayClass = (item: any) => {
	let arr: string[] = []
	if (item.sat) {
		arr.push('is-sat')
	}
	if (item.sun) {
		arr.push('is-sun')
	}
	if (year.value === curYear.value && month.value === curMonth.value && curDay.value === item.value) {
		arr.push('is-cur')
	}
	if (props.range) {
		if (year.value === start.value.year && month.value === start.value.month && item.value === start.value.day) {
			if (end.value.day) {
				arr.push('is-start')
			} else {
				arr.push('is-on')
			}
		}
		if (year.value === end.value.year && month.value === end.value.month && item.value === end.value.day) {
			arr.push('is-end')
		}
		const value = getValue({
			year: year.value,
			month: month.value,
			day: item.value
		})
		if (value > getValue(start.value) && value < getValue(end.value)) {
			arr.push('is-range')
		}
	} else {
		if (day.value === item.value && !(props.type === 'date' && props.multiple)) {
			arr.push('is-on')
		} else if (props.type === 'date' && props.multiple) {
			if (yearsData.value.includes(year.value) && monthsData.value.includes(addZero(month.value)) && daysRangeData.value.includes(`${year.value}-${addZero(month.value)}-${addZero(item.value)}`)) {
				arr.push('is-on')
			}
		}
	}
	return arr
}

// 界面控制
const nextMonth = () => {
	if (month.value === 12) {
		year.value += 1
		month.value = 1
	} else {
		month.value += 1
	}
	setDayData()
}

const lastMonth = () => {
	if (month.value === 1) {
		year.value -= 1
		month.value = 12
	} else {
		month.value -= 1
	}
	setDayData()
}

// const lastYears = () => {
// 	yearsPage.value -= 1
// 	setYearData(year.value + 10 * yearsPage.value)
// }

// const nextYears = () => {
// 	yearsPage.value += 1
// 	setYearData(year.value + 10 * yearsPage.value)
// }

const nextYear = () => {
	if (year.value >= Number(props.maxYear || 2200)) {
		return
	}
	isClickFlag.value = false
	year.value += 1
	commonSetDayVal()
}

const lastYear = () => {
	if (year.value <= Number(props.minYear || 1900)) {
		return
	}
	isClickFlag.value = false
	year.value -= 1
	commonSetDayVal()
}

const toggleMonthSelector = () => {
	if (!monthLayer.value) {
		// 打开
		monthLayer.value = true
		tempYear.value = year.value
		years.value = setYearData(year.value)
		isClickFlag.value = false
		goToCenter()
	} else {
		// 关闭
		monthLayer.value = false
	}
}

const hourScroll = ref()
const minuteScroll = ref()
const secondScroll = ref()

// 内置方法
// 验证日期格式
const isDate = (date: string) => {
	const DateExp = /^[1-2][0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/
	if (DateExp.test(date)) {
		return new Date(date).getDate() === Number(date.substring(date.length - 2))
	} else {
		return false
	}
}

const isMonth = (date: string) => {
	const DateExp = /^[1-2][0-9]{3}-(0[1-9]|1[0-2])$/
	if (DateExp.test(date)) {
		return new Date(date + '-01').getDate() === Number(1)
	} else {
		return false
	}
}

const isDatetime = (time: string) => {
	if (typeof time === 'string') {
		var reg = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/
		return reg.test(time)
	} else {
		return false
	}
}

const isAnyDate = (date: string) => {
	return isDate(date) || isMonth(date) || isDatetime(date)
}

// 获取某月天数
const getMonthDays = (date: string) => {
	const d = new Date(date)
	d.setMonth(d.getMonth() + 1, 0)
	return d.getDate()
}

// 格式化日期
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const formatDate = (date: Date, fmt: string) => {
	const o: any = {
		'M+': date.getMonth() + 1, // 月份
		'd+': date.getDate(), // 日
		'h+': date.getHours(), // 小时
		'm+': date.getMinutes(), // 分
		's+': date.getSeconds(), // 秒
		'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
		S: date.getMilliseconds() // 毫秒
	}
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	for (const k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
		}
	}
	return fmt
}

// 生成数字数组
const genNumbers = (min: number, max: number, step: number = 1) => {
	const arr: string[] = []
	for (let i = min; i <= max; i += step) {
		arr.push(String(i))
	}
	return arr
}

// 补零
const addZero = (str: string | number) => {
	if (Number(str) < 10) {
		return '0' + Number(str)
	} else {
		return String(str)
	}
}

const goToCenter = () => {
	nextTick(() => {
		const scrollRef = yearScrollRef.value?.$el as HTMLElement | null
		if (!scrollRef) return

		// const currentYear = new Date().getFullYear()
		const currentYear = year.value
		const currentIndex = years.value.findIndex(year => year === currentYear)

		// 获取第一个年份项，用于计算单个年份项的高度
		const firstItem = scrollRef.querySelector('.to-calendar-year-item') as HTMLElement | null
		if (!firstItem) return

		const itemHeight = firstItem.offsetHeight
		// 计算滚动位置，让当前年份在可视区域中间
		const scrollTop = currentIndex * itemHeight - scrollRef.clientHeight / 2 + itemHeight / 2

		scrollRef.scrollTop = Math.max(0, scrollTop)
	})
}

// 生命周期
onMounted(() => {
	if (props.minYear && props.maxYear && Number(props.minYear) > Number(props.maxYear)) {
		console.error('minYear 不能大于 maxYear')
	}
	setData()
	years.value = setYearData()

	goToCenter()
})

defineExpose({
	setData,
	addZero,
	year,
	month,
	day,
	hour,
	minute,
	second
})
</script>
